import { RouteDefinition } from 'src/stores/RouterStore/RouterStore.types';

export const filterMenuItems = (
    routes: RouteDefinition[],
): RouteDefinition[] => {
    return routes
        .filter((route) => route.menuTitle)
        .filter((route) => !route.unavailable)
        .filter((route) => !route.menuHide);
};

export const ifFeatureUnavailable = (permissions: boolean[]) => {
    return permissions.some((permission) => Boolean(permission));
};
